import type { ReactNode } from 'react';
import React from 'react';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';

import { ModalTransition } from '@atlaskit/modal-dialog';

import { RestrictionsDialogStateContainer } from '@confluence/restrictions-dialog-state-container';

import { RestrictionsDialogLoader } from '../RestrictionsDialog';
import { RestrictionsUpsellDialogLoader } from '../RestrictionsUpsellDialog';

import { IsUpsellQueryComponent } from './IsUpsellQueryComponent';

export type RestrictionsDialogMountPointProps = {
	contentId?: string;
};

export function RestrictionsDialogMountPoint({ contentId }: RestrictionsDialogMountPointProps) {
	return (
		<Subscribe to={[RestrictionsDialogStateContainer]}>
			{(dialogStateContainer: RestrictionsDialogStateContainer) => (
				<IsUpsellQueryComponent contentId={contentId}>
					{({ isUpsell }) => {
						let dialog: ReactNode;
						// Check if restrictions was clicked during SSR and a transition happened
						// In that scenario we don't want the restrictions dialog to render
						// For slow network while we wait for the dialog state to be reset
						// window?.__SSR_EVENTS_CAPTURE__?.restrictionsButton will only be set
						// during SSR or when window is SSR Rendered
						if (!window.__SSR_RENDERED__ && window?.__SSR_EVENTS_CAPTURE__?.restrictionsButton) {
							return null;
						}
						if (dialogStateContainer.getIsOpen()) {
							const onClose = (callback?: () => void) => {
								void dialogStateContainer.setIsOpen(false, null, callback);
							};

							dialog = isUpsell ? (
								<RestrictionsUpsellDialogLoader onClose={onClose} />
							) : (
								<RestrictionsDialogLoader
									contentId={dialogStateContainer.getContentId()}
									hideSpinner={() => dialogStateContainer.setHideRestrictionsButtonSpinner()}
									onClose={onClose}
								/>
							);
						}

						return <ModalTransition>{dialog}</ModalTransition>;
					}}
				</IsUpsellQueryComponent>
			)}
		</Subscribe>
	);
}
